export const INTA_CERRILLOS_CENTER = [-24.895, -65.4788];
export const INTA_CERRILLOS_LABEL = 'INTA Cerrillos';
export const CASE_LOCATION_DEFAULT_ZOOM = 14;
export const DASHBOARD_DEFAULT_ZOOM = 12;
